import PropTypes from 'prop-types';
import React from 'react'

export default class extends React.Component {
    static propTypes = {
		editing_fields: PropTypes.bool.isRequired,
		toggleEditFields: PropTypes.func.isRequired
	};

    render() {

		var { toggleEditFields, editing_fields } = this.props;

		return <span
			onClick={toggleEditFields}
			className={"clickable small text-dark-gray-xs " + (editing_fields ? 'text-light-success text-pale-success-hover' : 'text-dark-gray text-pale-gray-hover')}>

			<i className={"mright10 " + (editing_fields ? 'icon-check' : 'icon-pencil2')}></i>
			{ editing_fields ? 'Save changes' : 'Edit Profile'}

		</span>
	}
}


// WEBPACK FOOTER //
// ./src/js/views/Profile/components/ActionButtons/components/EditProfile.jsx